import React from 'react';
import OrderItems from './OrderItems';
import ActionButtons from './ActionButtons';

const OrderDetails = ({ 
    order, 
    language, 
    loading, 
    handlePrintReceipt, 
    setShowConfirmation 
}) => {
    if (!order) return null;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        
        if (language === 'ar') {
            const toArabicNumeral = (num) => num.toString().replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
            return `${toArabicNumeral(day)}/${toArabicNumeral(month)}/${toArabicNumeral(year)}`;
        }
        return `${day}/${month}/${year}`;
    };

    return (
        <div className="border rounded-lg p-4 space-y-3">
            <div className="flex justify-between">
                <span className="text-sm text-gray-500">
                    {language === 'ar' ? 'رقم الطلب:' : 'Order ID:'}
                </span>
                <span className="font-medium">{order.id}</span>
            </div>
            
            {order.total !== undefined && (
                <div className="flex justify-between">
                    <span className="text-sm text-gray-500">
                        {language === 'ar' ? 'المجموع:' : 'Total:'}
                    </span>
                    <span className="font-medium">{order.total.toFixed(2)}</span>
                </div>
            )}
            
            {order.created_at && (
                <div className="flex justify-between">
                    <span className="text-sm text-gray-500">
                        {language === 'ar' ? 'التاريخ:' : 'Date:'}
                    </span>
                    <span className="font-medium">
                        {formatDate(order.created_at)}
                    </span>
                </div>
            )}

            <OrderItems items={order.items} language={language} />
            
            <ActionButtons 
                loading={loading}
                language={language}
                handlePrintReceipt={handlePrintReceipt}
                setShowConfirmation={setShowConfirmation}
                order={order}
            />
        </div>
    );
};

export default OrderDetails;
